<template>
  <AppInput
    v-bind="$attrs"
    v-model="value"
    :label="label"
    :hint="hint"
    :pattern="/\d*/"
    type="tel"
    placeholder-char="_"
    :error="hideError ? '' : error"
    :theme="theme"
    icon-left
    :max-length="maxLength"
    @blur="setFormattedAmount"
    @input="handleInput"
    v-on="$listeners"
  >
    <slot
      v-for="(index, name) in $slots"
      :slot="name"
      :name="name"
    />
  </AppInput>
</template>

<script>
import AppInput from '@/components/common/inputs/AppInput'

export default {
  // Name
  name: 'AppCurrencyInput',

  // Components
  components: {
    AppInput
  },

  // Inherit Attrs
  inheritAttrs: false,

  // Props
  props: {
    fieldName: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'aggressive'
    },
    rules: {
      type: String,
      default: ''
    },
    hideError: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'green'
    },
    hint: {
      type: String,
      default: ''
    },
    initValue: {
      type: String,
      default: ''
    },

    error: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      value: ''
    }
  },

  computed: {
    parsedCurrencyInt () {
      if (!this.isHourly) {
        return this.value ? this.value.replace(/\D/g, '') : ''
      } else { return this.value }
    },

    maxLength () {
      const maxCurrency = this.rules.split('|').find(rule => rule.split(':')[0] === 'max_currency')
      return maxCurrency ? maxCurrency.split(':')[1].length : undefined
    },

    isHourly () {
      return this.label.includes('Hourly')
    }

  },

  mounted () {
    this.getInitialValue()
  },

  methods: {
    getInitialValue () {
      if (!this.isHourly) {
        this.value = this.initValue.replace(/[^0-9,]/g, '')
      } else {
        // remove all non digits only two digits after decimal
        this.value = this.initValue?.replace(/,/g, '.')?.replace(/[^\d.]/g, '')?.replace(/^([^.]*\.[0-9]{0,2}).*$/, '$1')
      }
      this.setFormattedAmount()
    },

    formatAsCurrency (value) {
      return value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },

    setFormattedAmount () {
      if (this.isHourly) {
        this.value = this.value.replace(/^([^.]*\.[0-9]{0,2}).*$/, '$1')
      } else {
        this.value = this.formatAsCurrency(this.parsedCurrencyInt)
      }

      // $emit raw integer parsed from the currency value
      this.$emit('input-blur', this.parsedCurrencyInt)
    },

    handleInput (value) {
      if (this.isHourly) {
        this.value = value?.replace(/,/g, '.')?.replace(/[^\d.]/g, '')?.replace(/^([^.]*\.[0-9]{0,2}).*$/, '$1')
      } else {
        this.value = value.replace(/[^0-9,]/g, '')
      }
    }
  }
}
</script>

<style scoped lang="scss">
:deep() .app-input__wrapper {
  // add dollar sign to input with pseudo selector
  &::before {
    content: '$';
    transform-origin: 0 0;
    transform: translate3d(0, 0, 0);
    transition: transform 175ms ease-out;

    @apply top-[15px] left-[15px] absolute z-1;

    @screen sm {
      @apply top-[16px];
    }
  }

  // hide label instead of floating it as default component does
  &--floating {
    &::before {
      transform: translate3d(0, 6px, 0);

      @screen sm {
        transform: translate3d(0, 8px, 0);
      }
    }
  }
}
</style>
